export const ROUTE_LOADING_START_EVENT = "dispatchiq:route-loading-start";

export interface RouteLoadingStartDetail {
    immediate?: boolean;
}

export function startGlobalRouteLoading(
    detail: RouteLoadingStartDetail = {}
): void {
    if (typeof window === "undefined") {
        return;
    }

    window.dispatchEvent(
        new CustomEvent<RouteLoadingStartDetail>(ROUTE_LOADING_START_EVENT, {
            detail,
        })
    );
}
